import { Flex, HStack, Icon, SimpleGrid, Text } from "@chakra-ui/react";
import { FaUser } from "react-icons/fa";
import { CreditAuctionProposal } from "@/models/credit-auction-proposal.model";
import { documentFormatter } from "@/utils/documentFormatter";
import { BrlCurrencyFormatter } from "@/utils/BrlCurrencyFormatter";
import { DetailRow } from "../detail-row";

interface ProposalClientCardProps {
  payload: CreditAuctionProposal;
}

export function ProposalClientCard({ payload }: ProposalClientCardProps) {
  const pepLabel =
    payload.PessoaExpostaPoliticamente.Descricao === "Não informado"
      ? "Não informado"
      : payload.PessoaExpostaPoliticamente.Codigo === 0
      ? "Não Exposta"
      : "Exposta";

  return (
    <Flex
      bg="white"
      border="1px solid"
      borderColor="#E2E8F0"
      borderRadius="16px"
      px={{ base: 4, md: 5 }}
      py={4}
      direction="column"
      gap={4}
    >
      <HStack spacing={3} align="center" justify="center">
        <Icon as={FaUser} color="secondary" boxSize={4} />
        <Text
          fontFamily="Lexend Deca"
          fontWeight="500"
          fontSize="sm"
          color="secondary"
          letterSpacing="0.04em"
          textTransform="uppercase"
        >
          Dados Tomador
        </Text>
      </HStack>

      <Text
        fontSize="xl"
        fontWeight="500"
        color="#1E293B"
        lineHeight="1.2"
        fontFamily="Lexend Deca"
        textAlign="center"
      >
        {payload.NomeTrabalhador}
      </Text>

      <SimpleGrid columns={1} spacingY={3}>
        <DetailRow label="CPF" value={documentFormatter(payload.Cpf)} copyable />
        <DetailRow label="Telefone" value={payload.Telefone} copyable />
        <DetailRow label="Email" value={payload.Email} copyable valueFontSize="xs" />
        <DetailRow
          label="Idade"
          value={
            payload.Idade !== null ? `${payload.Idade} anos` : "Não informado"
          }
        />
        <DetailRow label="Sexo" value={payload.Sexo} />
        <DetailRow label="Status PEP" value={pepLabel} />
        <DetailRow
          label="Valor Liberado"
          value={BrlCurrencyFormatter(payload.ValorLiberado)}
          badge
        />
      </SimpleGrid>
    </Flex>
  );
}
